import { render, staticRenderFns } from "./InterestsHeaderIcon.vue?vue&type=template&id=46c51864&scoped=true&"
import script from "./InterestsHeaderIcon.vue?vue&type=script&lang=js&"
export * from "./InterestsHeaderIcon.vue?vue&type=script&lang=js&"
import style0 from "./InterestsHeaderIcon.vue?vue&type=style&index=0&id=46c51864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c51864",
  null
  
)

export default component.exports